export default __webpack_public_path__ + "ba6d733d87a26df5fc7cd808afaaa79f.svg";